<template>
  <div class="comment-list">
    <div
      v-for="(item, index) in reverseComments"
      class="comment-list-item"
      :key="index"
      ref="current_comment"
    >
      <div>
        <img :src="getPhoto(item.uid)" />
        <div>
          <div>{{getName(item.uid)}}</div>
          <div>{{item.time}}</div>
        </div>
      </div>
      <div class="comment-list-item-content">{{item.content}}</div>
      <div class="comment-list-item-footer">
        <span style="margin-right: 27px;" @click="likeCurrentComment(index, item.likes)">
          <i class="iconcool iconcool-like like-comment" style="margin-right: 4px" :class="{'unlike-comment': !isLike(index)}" />
          <span>{{item.likes && item.likes.length || 0}}</span>
        </span>
        <span @click="replyComment(index, item.uid.uid, getName(item.uid), '00')">
          <img :src="replyUrl" style="margin-right: 4px" />
          <span class="comment-list-item-reply">回复</span>
        </span>
      </div>
      <div class="comment-reply-user">
        <div v-for="(replcomment, key) in (needOpen[index] ? item.comments.slice(0, 3) : item.comments)" class="comment-reply-user-item" :key="index + key">
          <div>
            <span class="username">{{getName(replcomment.uid)}}</span>
            <span>回复</span>
            <span class="username">{{getName(replcomment.toUserId)}}</span>
            <span>{{replcomment.content}}</span>
          </div>
          <div style="display:flex; align-items: center;margin-top: 5px;">
            <span>{{replcomment.time}}</span>
            <span class="comment-reply-user-reply" @click="replyComment(index, replcomment.uid.uid, getName(replcomment.uid), key)">
              <img :src="replyUrl" style="margin-right: 4px; width: 20px;" />
              <span class="comment-list-item-reply">回复</span>
            </span>
          </div>
        </div>
        <div v-if="needOpen[index]">还有{{item.comments.length - 3}}条评论，<span class="username" @click="seeMore(index)">点击查看</span></div>
        <el-collapse-transition>
          <comment
            :head="false"
            v-if="reply === index"
            :commentListIndex="realIndex(index) + ''"
            :toUserId="toUserId"
            :toUserName="toUserName"
            @cancel="cancel"
          />
        </el-collapse-transition>
      </div>
    </div>
  </div>
</template>
<script>
import {mapGetters, mapActions} from 'vuex'
import like from "@/assets/img/like.png";
import reply from "@/assets/img/reply.png";
import Comment from "./Comment";
export default {
  name: "comment-list",
  data() {
    return {
      reply: null,
      likeUrl: like,
      toUserId: '',
      toUserName: '',
      replyIndex : null,
      replyUrl: reply,
      needOpen: [],
    };
  },
  computed: {
    ...mapGetters('home', ['user']),
    reverseComments () {
      return this.comments.slice().reverse()
    }
  },
  components: { Comment },
  props: ["comments", "id"],
  watch: {
    'comments': function (val) {
      if(!val) return
       val.slice().reverse().forEach((element, index) => {
        this.needOpen[index] = (element.comments && element.comments.length > 3) ? true :  false
      })
    }
  },
  methods: {
    ...mapActions('post', ['likeComment']),
    replyComment(index, toUserId, toUserName, replyIndex) {
      if(this.replyIndex === replyIndex && index === this.reply) {
        this.reply = null
        this.replyIndex = null
        this.toUserId = ''
        this.toUserName = ''
        return
      }
      this.reply = null
      this.$nextTick(() => {
        this.toUserId = toUserId
        this.toUserName = toUserName
        this.reply = index
        this.replyIndex = replyIndex
      })
    },
    /**
     * 点赞评论
     */
    async likeCurrentComment (index) {
      if(!this.user) {
        this.isLogin('登录后点赞')
        return
      }
      let realIndex = this.realIndex(index)
      if(this.isLike(index)) return
      await this.likeComment({
        id: this.id,
        commentIndex: realIndex
      })
      this.$message({
        message: '点赞成功',
        type: 'success'
      })
    },
    cancel() {
      this.reply = null
    },
    realIndex (index) {
      return this.comments.length - 1 - index
    },
    isLike (index) {
      if(!this.user) return false
      let commentIndex = this.realIndex(index)
      if(typeof this.comments[commentIndex].likes === 'undefined') return false
      let isLike = this.comments[commentIndex].likes.indexOf(this.user.uid) > -1
      return isLike
    },
    seeMore (index) {
      this.$set(this.needOpen, index, false)
    }
  }
};
</script>
<style lang="scss" scoped>
.comment-list {
  > .comment-list-item {
    border-top: 1px solid #eaeaea;
    padding: 20px 0;
    > :first-child {
      display: flex;
      justify-content: flex-start;
      img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
      }
      > div {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        margin-left: 19px;
        > :first-child {
          font-size: 16px;
          font-family: MicrosoftYaHei-Bold;
          font-weight: bold;
          color: rgba(51, 51, 51, 1);
          line-height: 21px;
          text-align: left;
        }
        > :nth-child(2) {
          font-size: 12px;
          color: rgba(153, 153, 153, 1);
          line-height: 20px;
        }
      }
    }
    > .comment-list-item-content {
      margin: 9px 0 14px;
      font-size: 16px;
      font-family: MicrosoftYaHei;
      color: rgba(51, 51, 51, 1);
      line-height: 28px;
      text-align: left;
    }
    > .comment-list-item-footer {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      .unlike-comment {
        &:hover {
          color: #333333;
        }
      }
      .like-comment {
        color: rgb(153, 153, 153)
      }
      img {
        width: 20px;
      }
      > span {
        display: flex;
        align-items: center;
        &:hover {
          cursor: pointer;
        }
      }
    }
    > .comment-reply-user {
      border-left: 3px solid #eaeaea;
      padding-left: 20px;
      .comment-reply-user-item {
        text-align: left;
        :first-child {
          > * {
            margin-right: 4px;
          }
        }
        margin-bottom: 34px;
        .comment-reply-user-reply {
          display: flex;
          align-items: center;
          margin-left: 21px;
          &:hover {
            cursor: pointer;
          }
        }
      }
      .username {
        color: #3c80e3;
        &:hover {
          cursor: pointer;
        }
      }
    }
  }
}
</style>


